export default __webpack_public_path__ + "static/media/TextLogo.672c29db.svg";